const useMatrixBarChartData = (reportData) => {
  const chartData = reportData.options.reduce((data, option) => {
    const { label, values } = option;
    const valuesMap = values?.reduce((map, value) => {
      const { weightId, count, percentage } = value;

      return { ...map, [weightId]: { count, percentage } };
    }, {});

    return [...data, { label, values: valuesMap }];
  }, []);

  return chartData;
};

export default useMatrixBarChartData;
